import { type OrderDto } from '@/shared/api/order';
import { updateOrderItems, type UpdateOrderItemsRequestParams } from '../api/api';
import { endUpdateOrderSide, startUpdateOrderSide } from '../slices';

interface UpdateOrderProductQuantityParams extends UpdateOrderItemsRequestParams {
    reinitialize: (orderDto: OrderDto) => void;
}

export const updateOrderProductQuantity = async ({
    store_slug,
    signature,
    order_id,
    items,
    reinitialize,
}: UpdateOrderProductQuantityParams) => {
    try {
        startUpdateOrderSide();

        const updatedOrder = await updateOrderItems({
            items,
            order_id,
            signature,
            store_slug,
        });

        if (updatedOrder.is_success) {
            reinitialize(updatedOrder.order);
        }
    } finally {
        endUpdateOrderSide();
    }
};
